export default "__VITE_ASSET___Mn5$jIW__"